import { Link } from "react-router-dom";
import { assets, hostBenefits, HOST_ROUTE } from "../data.ts";
import { ImageSlot } from "./ImageSlot.tsx";
import { Reveal } from "./Reveal.tsx";
import { IconArrowRight, IconCheck } from "./icons.tsx";

export function HostEvents() {
  return (
    <section id="host" aria-label="Host Events" className="bg-cream pb-20 pt-20 text-[#141210] md:pb-28 md:pt-28 lg:pb-[130px] lg:pt-[120px]">
      <div className="mx-auto max-w-shell px-5 md:px-8 lg:px-12">
        <Reveal className="mb-[60px] max-w-[760px]">
          <div className="mb-5 font-mono text-xs uppercase tracking-[.28em] text-flame">For organizers</div>
          <h2 className="m-0 mb-[22px] font-archivo text-[clamp(36px,4.6vw,66px)] font-extrabold leading-[1] tracking-[-.03em]">
            Built for the people
            <br />
            who run them.
          </h2>
          <p className="m-0 max-w-[52ch] text-lg leading-[1.6] text-[#46413c]">
            From a Sunday Cars &amp; Coffee to a three-day airshow — register attendees, capture leads, check people in
            and grow your community. The tools fade into the background. The event takes the stage.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
          {/* photo with outcome chips */}
          <Reveal className="relative aspect-[4/5] overflow-hidden rounded-[6px] shadow-[0_30px_60px_-40px_rgba(20,18,16,.5)]">
            <ImageSlot
              src={assets.forOrganizers}
              alt="Organizer at the gate — check-in, wristbands, the crowd rolling in"
              placeholder="Organizer at the gate — check-in, wristbands, the crowd rolling in"
              parallax={0.04}
              className="absolute inset-x-0 -top-[6%] h-[112%] w-full"
            />
            <div className="absolute left-[22px] top-[22px] flex items-center gap-[11px] rounded-[13px] bg-white/[.92] px-4 py-3 shadow-[0_10px_30px_-12px_rgba(0,0,0,.4)] backdrop-blur-[8px]">
              <div className="flex h-[34px] w-[34px] items-center justify-center rounded-[9px] bg-flame text-white">
                <IconCheck size={17} />
              </div>
              <div>
                <div className="text-base font-extrabold leading-none">4s</div>
                <div className="mt-[3px] font-mono text-[10px] uppercase tracking-[.1em] text-[#76706a]">
                  Avg check-in
                </div>
              </div>
            </div>
            <div className="absolute bottom-[22px] right-[22px] flex items-center gap-[11px] rounded-[13px] bg-[rgba(20,18,16,.82)] px-4 py-3 backdrop-blur-[8px]">
              <div>
                <div className="text-lg font-extrabold leading-none text-white">312</div>
                <div className="mt-[3px] font-mono text-[10px] uppercase tracking-[.1em] text-white/60">
                  Leads captured
                </div>
              </div>
            </div>
          </Reveal>

          {/* benefits */}
          <Reveal delay={120}>
            <div className="mb-[34px] grid grid-cols-1 gap-3.5 sm:grid-cols-2">
              {hostBenefits.map((benefit) => (
                <div
                  key={benefit.title}
                  className="rounded-[13px] border border-[#e6e1d8] bg-white px-[22px] py-6 transition hover:-translate-y-[3px] hover:border-flame"
                >
                  <benefit.icon size={22} className="mb-4 text-flame" />
                  <div className="mb-1.5 text-base font-bold">{benefit.title}</div>
                  <div className="text-[13.5px] leading-[1.5] text-[#76706a]">{benefit.body}</div>
                </div>
              ))}
            </div>
            <Link
              to={HOST_ROUTE}
              className="inline-flex items-center gap-2.5 rounded-xl border border-flame bg-flame px-[30px] py-4 text-base font-bold text-white no-underline transition hover:-translate-y-0.5 hover:border-flame-dark hover:bg-flame-dark"
            >
              Host an Event <IconArrowRight size={17} />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
